<template>
  <div>
    <styled-title>Play a song</styled-title>
    <button @click.prevent='play'>
        Play
    </button>
    <div id="Notes">
			<div v-if="this.showC4" class="Note">C4</div>
			<div v-if="this.showD4" class="Note">D4</div>
			<div v-if="this.showE4" class="Note">E4</div>
			<div v-if="this.showF4" class="Note">F4</div>
			<div v-if="this.showG4" class="Note">G4</div>
		</div>
  </div>
</template>

<script>
// let webaudiofont = require('webaudiofont')
// let player = new WebAudioFontPlayer()
/*
import MIDI from 'midi.js'
MIDI.loadPlugin({
  instrument: 'bassoon',
  soundfontUrl: '/static/soundfonts/',
  onsuccess: function () {
    alert('loaded')
  }
})
*/

import Tone from 'tone'
// import * as MidiConvert from 'midiconvert'

export default {
  data () {
    return {
      'showC4': true,
      'showD4': false,
      'showE4': false,
      'showF4': false,
      'showG4': false
    }
  },
  methods: {
    play () {
      // MidiConvert.load('/static/midi/test.mid', function (midi) {
      fetch('/static/midi/bach.json')
        .then(function (response) {
          let json = response.json()
          console.log(json)
          return json
        })
        .then(function (midi) {
          let synth = new Tone.PolySynth(8, Tone.Synth).toMaster()

          // make sure you set the tempo before you schedule the events
          Tone.Transport.bpm.value = midi.header.bpm

          // pass in the note events from one of the tracks as the second argument to Tone.Part
          var part = new Tone.Part(function (time, note) {
            // use the events to play the synth
            synth.triggerAttackRelease(note.name, note.duration, time, note.velocity)

            if (note.name === 'D4') {
              Tone.Draw.schedule(function () {
                // the callback synced to the animation frame at the given time
                this.showD4 = true
              }, time)
            } else {

            }
          }, midi.tracks[1].notes) // Note, this was on Second track?

          console.log(midi)
          console.log(part)

          // start the transport to hear the events
          part.start(0)
          console.log('Tone.part: ', part.state)

          Tone.Transport.start()
          console.log('Tone.Transport: ', Tone.Transport)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PlayerView.vue